var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPhone = function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon-phone_svg__a",
    width: 25,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.19 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-phone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.14 21c-2.08 0-4.14-.45-6.17-1.36-2.04-.91-3.89-2.2-5.55-3.87a18.47 18.47 0 0 1-3.87-5.54c-.9-2.04-1.36-4.1-1.36-6.18A1.02 1.02 0 0 1 4.24 3H8.3c.23 0 .44.08.63.24.18.16.29.34.32.56l.65 3.5c.03.27.03.5-.02.67-.05.19-.15.35-.28.48L7.17 10.9c.33.62.73 1.21 1.18 1.79.46.57.97 1.13 1.52 1.66A17.58 17.58 0 0 0 13.29 17l2.35-2.35a1.61 1.61 0 0 1 1.3-.4l3.45.7c.23.07.43.19.58.36.15.18.22.37.22.59v4.05A1.02 1.02 0 0 1 20.14 21ZM6.22 9l1.65-1.65L7.44 5H5.22c.08.68.2 1.36.35 2.03.15.66.36 1.32.65 1.97Zm8.95 8.95a12.42 12.42 0 0 0 4.02 1v-2.2l-2.35-.48-1.67 1.68Z"
  }))));
};
export default SvgIconPhone;